import React from 'react'

const SearchSpinner = ({type}) => (
    <div class={`spinner-border spinner-custom spinner-border-sm ${type}`} role="status">
        <span class="sr-only">Loading...</span>
    </div>
)

export default SearchSpinner;